<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202307_01.jpg" class="only_pc" />
        <img src="@/assets/img/column/202307_01_sp.jpg" class="only_sp" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-left">美肌菌を美容皮膚科医の90%が推奨</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <h2 class="mt-5 pt-5">美肌に欠かせない「美肌菌」。美容皮膚科医の90%が推奨する「美肌菌」って？</h2>
    <div class="feature-row">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202307_02.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">美肌菌と悪玉菌の関係</h3>
        <p class="mb-3">「美肌菌」と呼ばれるお肌の常在菌があることをご存じでしょうか。</p>
        <p class="mb-3">「美肌菌」とはお肌をすこやかに保ち、うるおいを生み出す、肌本来の持つバリア機能を強化してくれる良い菌です。</p>
        <p class="mb-3">一方でお肌には、肌荒れの原因となる「悪玉菌」も存在します。</p>
        <p>お肌には美肌菌、悪玉菌の他にも日和見菌と呼ばれるものなど、多くの菌が常在しそのバランスに肌の状態は左右されると言われています。</p>
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">美肌に欠かせないと最近話題の「美肌菌」</h3>
        <p class="mb-3">マナビス化粧品は、全国の30代～50代女性の方1,005名を対象に、「美肌菌と悪玉菌に関する実態調査」を実施。</p>
        <p class="mb-3">美肌菌について約6割の方は知らないと回答。</p>
        <p>では今、美容マニアから一般の方まで、幅広く注目されている「美肌菌」とは？</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202307_03.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202307_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">美容皮膚科医の約9割が「美肌菌」はお肌にとって重要と回答</h3>
        <p class="mb-3">同様に全国の美容皮膚科医1,005名を対象に「美肌菌と悪玉菌の関係」に関する調査を実施。アンケート結果（*2）から「美肌菌」の重要性が伺えます。</p>
        <p class="mb-3">そこで気になるのは美肌菌の減少により起こるお肌トラブル。</p>
        <p>『ニキビ』『乾燥』『かゆみ』などが起きやすくなることが考えられるとのこと。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">美肌菌を増やす・育てるために行うべきケアは？</h3>
        <p class="mb-3">美容皮膚科医へのアンケート（*2）結果では<strong>『肌の摩擦を避ける（46.6％）』</strong>が最多。</p>
        <p class="mb-3">次いで<strong>『紫外線対策を行う（44.4％）』『適度な皮脂を残す（44.0％）』</strong>と回答。</p>
        <p>日頃からのコツコツとしたスキンケアが重要なことがわかります。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202307_05.jpg">
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202307_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">一般の方のケアでは美肌菌を育てるには不十分！？</h3>
        <p class="mb-3">同アンケート（*2）で美容皮膚科医へ「一般の方のスキンケア方法は美肌菌を増やす・育てるために十分と言えますか？」と質問したところ、7割以上の方が十分と回答。</p>
        <p class="mb-3">一方で、気になるのは不十分の理由。アンケート結果から一部をご紹介します。</p>
        <p class="mb-3">『内側からのケアが大切だから』<br>『皮脂を落としすぎているから』</p>
        <p>こう聞くと、より効果的な「美肌菌」を増やすケアが気になるところ。</p>
      </div>
    </div>
    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3">そして「悪玉菌」って？減らすためのケアとは</h3>
        <p class="mb-3">前提として、お肌の悪玉菌が増えると『ニキビ』『かゆみ』『乾燥』と「美肌菌」の減少時と同様のお肌トラブルが起きやすいと言われています。</p>
        <p class="mb-3">同アンケート（*2）内で、美容皮膚科医に「悪玉菌」を減らすケアについてヒアリング。</p>
        <p>こちらも<strong>『ストレスを溜めない』『肌を清潔に保つ』</strong>など日常生活ですこやかに過ごすこ回答が目立ちました。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202307_07.jpg">
      </div>
    </div>

    <div class="my-5 py-5 text-center">
      <h2 class="mb-3">お肌をすこやかに保つために</h2>
      <p class="mb-3">毎日のクレンジングや洗顔は大切ですが、正しくケアをしないと<br>お肌に必要な皮脂や皮膚常在菌まで取り去ってしまい、肌のうるおいもなくなってしまいます。</p>
      <p class="mb-3">そこでマナビス化粧品は「美肌菌」に着目。</p>
      <p class="mb-5">美肌菌に適した環境が保てるように"うるおす・守る"サポートをし、<br>お肌の菌のバランスにアプローチするスキンケアラインを開発しました。</p>
      <h3>そこで生まれたのが「フローラシリーズ」です。</h3>
    </div>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202307_08.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left">FLORA</h2>
        </div>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3"><small>マナビス化粧品が着目する</small></p>
        <p class="mb-3 fs-2">美肌菌とは</p>
        <p class="mb-3">美肌菌とは、うるおい成分の生産・持続、肌バリア機能の保護など肌に良い働きをしてくれます。</p>
        <p class="mb-5">その代表である「表皮ブドウ球菌」は、水分の蒸発を防ぎ、<br>うるおいを保つ"グリセリン"と肌を弱酸性に保つ"脂肪酸"を作り出します。</p>
        <p class="mb-3">毎日のクレンジングや過度な洗顔によって、必要な皮脂、皮膚常在菌まで取り去ってしまい<br>肌のうるおいがなくなってしまうことがあります。</p>
        <p>そこで、『フローラ』は美肌菌に着目し、<br>美肌菌に適した環境が保てるような"うるおす・守る"サポートをしています。</p>
      </div>
    </div>

    <div class="feature-row pt-5">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202307_09.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <h3 class="mb-3"><small>マナビスだけのオリジナル処方</small><br>スキンバランシングフォーミュラF（整肌）</h3>
        <p class="mb-3">肌の調子を整える”スキンバランシングフォーミュラF”は、美肌菌に着目した<strong>マナビスの独自処方</strong>です。</p>
        <p class="mb-3">【善玉菌（美肌菌）が喜ぶ環境】を作り出す乳酸桿菌/豆乳発酵液の「乳酸菌生産物質」に加え、グレープフルーツ果実エキス、グレープフルーツ種子エキスなどをはじめとする8つの植物由来成分を組み合わせた「フルーツコンプレックスＭ」を配合することで【悪玉菌が増えにくい環境】を作り出しています。これがマナビスだけのオンリーワン処方「スキンバランシングフォーミュラＦ」です。</p>
        <p>洗顔直後の肌の角層に直接アプローチすることで、こだわり抜いた整肌成分でうるおいを保つサポートをし、理想の肌へと導きます。</p>
      </div>
    </div>

    <div class="my-5 py-5 text-center">
      <h2 class="mb-3">体内・外からの日々のお手入れでみずみずしいお肌へ。</h2>
      <p>フローラの"内外美容"で、美しく、あなたらしい毎日を手に入れてみませんか？</p>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/flora_trialset_202307.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">FLORA<br>美肌菌トライアルセット（約7日間）</h3>
        <p class="mb-3">¥3,000</p>
        <p>ファーストセラムとスキンケアオイルのミニサイズを詰め合わせた、初めての方に使っていただきたいセットです。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">FLORA<br>フローラ ファーストセラム</h3>
        <p class="mb-3">¥7,700</p>
        <p>すこやかさのカギを握る美肌菌と<br>皮膚常在菌のバランスに着目した、<br>洗顔後すぐに使う導入化粧液。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/flora_firstserum_202307.jpg">
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/flora_skincareoil_202307.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">FLORA<br>フローラ スキンケアオイル</h3>
        <p class="mb-3">¥7,700</p>
        <p>植物由来成分配合の美容液層とオーガニック成分４種配合のオイル層。<br>美肌菌に着目した、二層の美容オイル。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
    </div>
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">FLORA<br>フローラ サプリメント ベーシック</h3>
        <p class="mb-3">¥6,300</p>
        <p>からだのなかから、すこやかに、美しく。<br>乳酸菌・酵母菌・乳酸菌生産物質を配合した、<br>マナビス化粧品初のサプリメント。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/flora_supplementbasic_202307.jpg">
      </div>
    </div>

    <h2 class="my-5 py-5">お客様の声</h2>
    <div class="feature-row feature-row_voice_list pb-0">
      <div class="feature-row_voice_item">
        <h3 class="mb-3">フローラ サプリメント ベーシック</h3>
        <p class="mb-3"><img src="@/assets/img/column/voice_202307_01.jpg"></p>
        <p class="mb-3">インナービューティーを目指して飲み始めました。飲みはじめてお肌の調子が落ち着いてきたと感じています。</p>
        <p class="mb-3">美肌ケアは継続が大事だと改めて思います。</p>
        <p>20代 女性</p>
      </div>
      <div class="feature-row_voice_item">
        <h3 class="mb-3">スキンケアオイル</h3>
        <p class="mb-3"><img src="@/assets/img/column/voice_202307_02.jpg"></p>
        <p class="mb-3">美容マニアの友人の勧めでハマりました。 美肌菌へのアプローチや植物由来成分配合などしっかり作られた商品で安心して使えます！</p>
        <p class="mb-3">敏感肌ですが乾燥しなくなったし、自分の肌力が整ってきて嬉しい。</p>
        <p>30代 女性</p>
      </div>
      <div class="feature-row_voice_item">
        <h3 class="mb-3">スキンケアオイル</h3>
        <p class="mb-3"><img src="@/assets/img/column/voice_202307_02.jpg"></p>
        <p class="mb-3">この一本に出会って肌運命が変わりました。<br>しっかり潤うのにベタつかないし、使用した翌朝のお肌のコンディションが全然違う。</p>
        <p class="mb-3">香りもナチュラルで好き。肌を「キレイ」と褒められることが増えたし今後もずっと使いたい。</p>
        <p>20代 女性</p>
      </div>
    </div>
    <div class="feature-row feature-row_voice_list">
      <div class="feature-row_voice_item">
        <h3 class="mb-3">ファーストセラム</h3>
        <p class="mb-3"><img src="@/assets/img/column/voice_202307_03.jpg"></p>
        <p class="mb-3">混合肌でベタベタと乾燥で悩んでいましたが、こちらを使い出して化粧水などスキンケアの浸透が良くなった。</p>
        <p class="mb-3">潤うけどベタつかないし、使いやすいです。</p>
        <p>40代 女性</p>
      </div>
      <div class="feature-row_voice_item">
        <h3 class="mb-3">ファーストセラム</h3>
        <p class="mb-3"><img src="@/assets/img/column/voice_202307_03.jpg"></p>
        <p class="mb-3">美肌菌が気になって、購入。トロッとしたテクスチャーで潤うし、スキンケアのファーストステップとして適している。この後の乳液や美容液の浸透が改善した。</p>
        <p>30代 女性</p>
      </div>
    </div>

    <div class="text-center mb-5 pb-5">
      <p>アンケートの詳細は以下からご覧いただけます。</p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000001.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000001.000124389.html">【美肌菌と悪玉菌の関係に関する調査】約9割が美肌菌は重要だと回答！悪玉菌を減らす方法とは？</a></p>
      <p><a href="https://prtimes.jp/main/html/rd/p/000000002.000124389.html" target="_blank" title="https://prtimes.jp/main/html/rd/p/000000002.000124389.html">『美肌菌』って意外と知られていない？30代～50代女性に聞いた、美肌菌と悪玉菌に関する実態調査</a></p>
    </div>

    <div class="rte">
      <font size="1">
        <p class="mb-3">一般の方へのアンケート*1<br>
        調査概要：「美肌菌と悪玉菌に関する実態調査」<br>
        【調査期間】2023年6月5日（月）〜2023年6月6日（火）<br>
        【調査方法】リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】1,005人<br>
        【調査対象】調査回答時に30代～50代女性であると回答したモニター<br>
        【モニター提供元】ゼネラルリサーチ</p>
        <p>美容皮膚科医の方へのアンケート*2<br>
        【調査概要】：「美肌菌と悪玉菌の関係」に関する調査<br>
        【調査期間】：2023/06/14（火）～2023/06/15（水）<br>
        【調査方法】：リンクアンドパートナーズが提供する調査PR「RRP」によるインターネット調査<br>
        【調査人数】：1,005名<br>
        【調査対象】：調査回答時に美容皮膚科医であると回答したモニター<br>
        【モニター提供元】：ゼネラルリサーチ<br>
        ※この調査の内容は、あくまで美容皮膚科医の方を対象にしたアンケート結果の紹介であり、効果や効能を実証するものではありません。</p>
      </font>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
  justify-content: flex-start;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px 5px 50px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text {
  position: absolute;
  right: 35px;
  bottom: 20px;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}
.layer_02 {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url('../../assets/img/column/202307_08.jpg');
  background-size: cover;
  min-height: 640px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 60px; /* テキストと画像の端の間に余白を設定 */
}
.layer_02 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_02 .layer-text .layer-text-inner h2 {
  font-size: 3em;
  color: #7e7e74;
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer_02 {
    min-height: 300px;
    padding: 15px;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>